/*
 *###############################################################################
 *Module Name                   : VoucherPurchaseController.js                     #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Friday, October 1st 2021, 3:20:00 pm          #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useState, useEffect } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, Col, Container, Row, CardBody, Alert } from "reactstrap"

//**Importing required componant files   */
import Breadcrumb from "components/Common/Breadcrumb"
import DPTopToolBar from "framework/widgets/DPTopToolBar"
import VoucherPurchaseOrderContent from "./VoucherPurchaseOrderContent"
import DPInfoBox from "framework/layout/DPInfoBox"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import { setVoucherSave, getVoucherPOHeader } from "./VoucherPurchaseController"
//*Detail content */
import VoucherPurchaseOrderDetails from "./VoucherPurchaseOrderDetails"

//**End Importing required componant files */
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from "react"
import DPPermission from "framework/widgets/DPPermission"
import DPPrintOption from "framework/widgets/DPPrintOptions"
import DPLoadingAlert from "framework/widgets/DPLoadingAlert"

const VoucherPurchaseOrder = props => {
  //*** User input related states */
  let today = new Date()
  let date = today.toISOString().split("T")[0]

  let history = useHistory();
  const {
    getMenuDetails, masterAuditLog, addtoFavourite
  } = useContext(Context);

  let time = process.env.REACT_APP_ALERTTIMEOUT; // alert display time in seconds 

  const [strVoucherCode, SetCode] = useState("") // Set Code
  const [blVoucherCodeEnable, SetVoucherCodeDisable] = useState(false)
  const [strVoucherDate, SetVoucherDate] = useState(date) //Set DATE
  const [blVoucherDateEnable, SetVoucherDateDisable] = useState(false)
  const [blSupplierEnable, SetSupplierDisable] = useState(false)

  const [blLocationEnable, SetLocationDisable] = useState(false)

  const [strRemarks1, SetRemarks1] = useState("")
  const [blRemarks1Enable, SetRemarks1Enable] = useState(false)
  const [strRemarks2, SetRemarks2] = useState("")
  const [blRemarks2Enable, SetRemarks2Enable] = useState(false)
  const [addNew, SetAddNew] = useState(true)

  const [strSupplier, SetSupplier] = useState("")
  const [supplierDesc, setSupplierDesc] = useState("")
  const [strLocation, SetLocation] = useState("")
  const [locationDesc, setLocationDesc] = useState("")
  const [supSearchDisable, setSupSearchDisable] = useState(false)
  const [locSearchDisable, setLocSearchDisable] = useState(false)
  const [strBatchNo, SetBatchNo] = useState("")
  const [blBatchNoEnable, SetBatchNoEnable] = useState(false)
  //*** End User input related states */
  //*** User input related Details level */
  const [dbSellingAmount, SetdbSellingAmount] = useState("0.0")
  const [dbGrossAmount, SetdbGrossAmount] = useState("0.0")
  const [dbDiscountPer, SetdbDiscountPer] = useState("0.0")
  const [dbItexAmount, SetdbItexAmount] = useState("0.0")
  const [dbETaxAmount, SetdbETaxAmount] = useState("0.0")
  const [dbAddAmount, SetdbAddAmount] = useState("0.0")
  const [dbDedAmount, SetdbDedAmount] = useState("0.0")
  const [dbNetAmount, SetdbNetAmount] = useState("0.0")
  const [TotalBookQty, setTotalBookQty] = useState("0.0")
  const [TotalCostValue, setTotalCostValue] = useState("0.0")
  const [TotalSellingValue, setTotalSellingValue] = useState("0.0")
  //*** User input related Details level */
  //*** User Activity related states*/
  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [AlertShow, setAlertShow] = useState(false)
  const [ShowTaxTable, setShowTaxTable] = useState(false)
  const [blDiasableGrid, SetblDiasableGrid] = useState(false)

  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [model_xlarge_sup, setmodel_xlarge_sup] = useState(false)
  const [model_xlarge_loc, setmodel_xlarge_loc] = useState(false)
  const [disabledDesc, setDisabledDesc] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [editEnable, setEditEnable] = useState(false)
  const [printEnable, setPrintEnable] = useState(false)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [SupplierOpen, SetSupplieropen] = useState(false)
  const [menuCode, SetMenuCode] = useState("")
  const [deleteEnable, SetDeleteEnable] = useState(false)
  //*** End User activity related staes */

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //*** useState to save table data */
  const [DataTables, SetDatatable] = useState([])
  const [LocationCode, setLocationCode] = useState("")
  //*** End of useStates */

  const [disabled, setDisabled] = useState(false)
  const [GridRows, setGridRows] = useState([{
    id: 1,
    code: "",
    desc: "",
    Cost: 0.0,
    Selling: 0.0,
    StartBook: 0,
    EndBook: 0,
    NoOfBook: 0,
    CostValue: 0,
    SellingValue: 0,
    rate: 0

  }])
  const [rowsTax, setTax] = useState([])
  const [SupplierTax, setSupplierTax] = useState([])
  const [strReason, setReason] = useState("Created")

  const [voucherProcess, setVoucherProcess] = useState(0)
  const [isProcessed, setIsProcessed] = useState("")

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(true)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)

  const [permissionGrantedAlertShow, setPermissionGrantedAlertShow] = useState(false)
  const [permissionGrantedAlertMsg, setPermissionGrantedAlertMsg] = useState("")
  const [permissionGrantedAlertColor, setPermissionGrantedAlertColor] = useState("")

  const [LogUserType, setLogUserType] = useState("")
  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)

  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  //*****Menu Rights End */
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")

  const [helpUrl, setHelpUrl] = useState("")

  //**Get File Details */
  useEffect(async () => {

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)

    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogCompanyCode(CompanyCode)
    setLogUserType(LogUserType)
    var requestOptions = {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetMenuAccess(result.data.strMenuAccessRight)
        SetMenuCreate(result.data.strMenuCreateRight)
        SetMenuDelete(result.data.strMenuDeleteRight)
        SetMenuModify(result.data.strMenuModifyRight)
        SetMenuPrint(result.data.strMenuPrintRight)
        SetMenuProcess(result.data.strMenuProcessRight)
        SetMenuName(result.data.strMenuName)
        SetMenuCode(result.data.strMenuTag)
        setPermissionReasonShow(result.data.strMenuReasonShow)
        setHelpUrl(result.data.strHelpUrl)
      }).catch(error =>
        console.log('error', error)
      );

  }, [])


  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])



  function handleAddRowNested() {
    const modifiedRows = [...GridRows]
    modifiedRows.push({
      id: modifiedRows.length == 0 ? 1 : modifiedRows[modifiedRows.length - 1].id + 1,
      code: "",
      desc: "",
      Cost: 0.0,
      Selling: 0.0,
      StartBook: 0,
      EndBook: 0,
      NoOfBook: 0,
      CostValue: 0,
      SellingValue: 0,
      rate: 0

    })
    setGridRows(modifiedRows)
    BookChange()

    // handleAddRowTax()
  }

  function handleRemoveRow(id, code) {

    var FilteredRows = GridRows.filter((row) => row.id !== id)

    if (FilteredRows.length == 0) {
      FilteredRows.push({
        id: 1,
        code: "",
        desc: "",
        Cost: 0.0,
        Selling: 0.0,
        StartBook: 0,
        EndBook: 0,
        NoOfBook: 0,
        CostValue: 0,
        SellingValue: 0,
        rate: 0
      })
    }

    var FilterTax = rowsTax.filter((row) => row.code != code)
    setGridRows(FilteredRows)
    setTax(FilterTax)

    BookChange(FilteredRows, FilterTax, 1)

  }


  function BookChange(FilteredArray = [], FilteredTax = [], id = 0) {

    let NoOfBook = 0
    let TotCostValue = 0
    let TotSellingValue = 0
    let TaxIncAmt = 0;
    let TaxIncTotal = 0;
    let TaxExAmt = 0;
    let TaxExTotal = 0;
    let NewTax = [];
    let TaxRows = [...rowsTax]

    //log time

    if (id != undefined && id != null && id == 1) {
      FilteredArray.map((obj, index) => {
        NoOfBook = parseFloat(NoOfBook) + parseFloat(obj.NoOfBook)
        TotCostValue = parseFloat(TotCostValue) + parseFloat(obj.CostValue)
        TotSellingValue = parseFloat(TotSellingValue) + parseFloat(obj.SellingValue)
      })

      FilteredTax.map((obj, index) => {
        if (obj.isInclude == 1) {
          TaxIncTotal = parseFloat(TaxIncTotal) + parseFloat(obj.TaxAmount);
        } else {
          TaxExTotal = parseFloat(TaxExTotal) + parseFloat(obj.TaxAmount);
        }
      })

      if (FilteredTax.length > 0 && FilteredArray.length > 0) {
        setShowTaxTable(true)
      } else {
        setShowTaxTable(false)
      }

    } else {
      GridRows.map((obj, index) => {
        NoOfBook = parseFloat(NoOfBook) + parseFloat(obj.NoOfBook)
        TotCostValue = parseFloat(TotCostValue) + parseFloat(obj.CostValue)
        TotSellingValue = parseFloat(TotSellingValue) + parseFloat(obj.SellingValue)
      })

      TaxRows.map((obj, index) => {
        if (obj.isInclude == 1) {
          TaxIncTotal = parseFloat(TaxIncTotal) + parseFloat(obj.TaxAmount);
        } else {
          TaxExTotal = parseFloat(TaxExTotal) + parseFloat(obj.TaxAmount);
        }
      })

      if (TaxRows.length > 0 && GridRows.length > 0) {
        setShowTaxTable(true)
      } else {
        setShowTaxTable(false)
      }

    }

    setTotalBookQty(parseFloat(NoOfBook))
    setTotalCostValue(parseFloat(TotCostValue).toFixed(2))
    SetdbGrossAmount(parseFloat(TotCostValue).toFixed(2))
    setTotalSellingValue(parseFloat(TotSellingValue).toFixed(2))

    // setTax(TaxRows)
    SetdbItexAmount(parseFloat(TaxIncTotal).toFixed(2))
    SetdbETaxAmount(parseFloat(TaxExTotal).toFixed(2))


    const valDic = DecimalValidation(dbDiscountPer)
    const valAdd = DecimalValidation(dbAddAmount)
    const valDed = DecimalValidation(dbDedAmount)

    var netAmount = parseFloat(TotCostValue) + parseFloat(TaxExTotal) + parseFloat(valAdd) - parseFloat(valDed) - (parseFloat(TotCostValue) * parseFloat(valDic) / 100)

    SetdbNetAmount(parseFloat(netAmount).toFixed(2))

  }

  function handleAddRowTax(code, desc) {
    const authToken = localStorage.getItem("authToken")
    if (code != "") {
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}VoucherPO/searchTax/${code}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      }).then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            const SupplierTax = responseData.data
            var newArray = []
            SupplierTax.map((item, index) => {
              newArray.push({
                id: index + 1,
                code: code,
                desc: desc,
                TaxCode: item.tax_Code,
                grossAmt: 0,
                TaxRate: item.tax_RAte,
                isInclude: item.tax_inclu,
                TaxAmount: 0,
              })
            })
            setSupplierTax(newArray)
          }
        })
    }
  }

  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  function tox_xlarge_sup() {
    setmodel_xlarge_sup(!model_xlarge_sup)
    removeBodyCss()
  }

  function tox_xlarge_loc() {
    setmodel_xlarge_loc(!model_xlarge_loc)
    removeBodyCss()
  }

  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  //save button function
  const handlesave = async (pro = 0) => {
    // e.preventDefault()

    var VoucherPoDet = []

    GridRows.map((item, index) => {
      if (item.code != "") {
        VoucherPoDet = VoucherPoDet.concat(
          VoucherPoBuilder(
            item.code,
            item.Cost,
            item.Selling,
            item.StartBook,
            item.NoOfBook,
            item.EndBook,
            item.CostValue,
            item.SellingValue
          ))
      }
    })

    if (VoucherPoDet.filter(x => parseFloat(x.DET_VCBQTY) == 0).length > 0) {
      displayAlertMessage('danger', "Number of Book can not be zero !")
      return
    }

    if (strSupplier == "") {
      displayAlertMessage('danger', "Please Select a supplier !")
      return
    }
    if (strLocation == "") {
      displayAlertMessage('danger', "Please Select a Location")
      return
    }

    if (!VoucherPoDet.length) {
      displayAlertMessage('danger', "Need to assign at least one Voucher group !")
      return
    }
    var VoucherPoTaxDet = []

    rowsTax.map((item, index) => {
      VoucherPoTaxDet.push(
        VoucherPoTaxBuilder(
          item.code,
          item.TaxCode,
          item.grossAmt,
          item.TaxRate,
          item.isInclude,
          item.TaxAmount
        )
      )
    })
    SetLoadingAlerttitle("Saving...")
    SetLoadingAlert(true)
    let strResult = await setVoucherSave(
      strVoucherCode,
      strVoucherDate,
      LocationCode,
      LogCompanyCode,
      strSupplier,
      strLocation,
      strRemarks1,
      strRemarks2,
      parseFloat(TotalSellingValue),
      parseFloat(dbGrossAmount),
      parseFloat(dbDiscountPer),
      parseFloat(dbItexAmount),
      parseFloat(dbETaxAmount),
      parseFloat(dbAddAmount),
      parseFloat(dbDedAmount),
      parseFloat(dbNetAmount),
      LogUserType,
      menuCode,
      LogCompanyCode,
      LocationCode,
      strReason,
      VoucherPoDet,
      VoucherPoTaxDet,
      pro,
      strBatchNo
    )
    SetLoadingAlert(false)
    if (strResult.status == "200") {
      strResult.json().then(responseData => {
        if (responseData.data == "Record Already Exsist!") {
          displayAlertMessage('danger', responseData.data)
        } else if (responseData.data == "Code Already Exsist!") {
          displayAlertMessage('danger', responseData.data)
        } else {
          handleNew()
          displayAlertMessage('success', responseData.data)
        }
      })
    } else if (strResult.status == "400") {
      strResult.json().then(responseData => {
        setAlertMsg(responseData.msg)
      })
      setAlertColor("danger")
      //setAlertMsg("Oops something went wrong !")
      setAlertShow(true)
    } else {
      handleNew()
    }
    setTimeout(() => {
      setAlertShow(false)
    }, 6000)
  }

  //Voucher Po table Array
  const VoucherPoBuilder = (
    code,
    Cost,
    Selling,
    StartBook,
    NoOfBook,
    EndBook,
    CostValue,
    SellingValue
  ) => {
    return {
      DET_TYPE: "VPO",
      DET_RUNNO: strVoucherCode,
      DET_SETUPLOC: "001",
      DET_VCCAT: code,
      DET_SPRICE: parseFloat(Selling),
      DET_CPRICE: parseFloat(Cost),
      DET_VCBSTART: parseFloat(StartBook),
      DET_VCBQTY: parseFloat(NoOfBook),
      DET_VCBEND: parseFloat(EndBook),
      DET_SVALUE: parseFloat(SellingValue),
      DET_CVALUE: parseFloat(CostValue),
    }
  }
  //Voucher Po table Array
  const VoucherPoTaxBuilder = (
    VGroupCode,
    Tax,
    GrossAmt,
    TaxRate,
    IsInclude,
    TaxAmount
  ) => {
    return {
      DET_VCCAT: VGroupCode,
      TDET_TAXCODE: Tax,
      TDET_GROAMT: parseFloat(GrossAmt),
      TDET_TAXRATE: parseFloat(TaxRate),
      TDET_TAXINC: IsInclude,
      TDET_TAXAMT: parseFloat(TaxAmount),
    }
  }

  //*** Get user selected row details */
  const GetSelectRow = (e, row, isSelect, rowIndex) => {
    SetCode(row.HED_RUNNO)
    ValueSetter(row.HED_RUNNO)
    setmodal_xlarge(!modal_xlarge)

  }

  const GetSelectRowSup = (e, row, isSelect, rowIndex) => {
    SetSupplier(row.SM_CODE)
    getSupplier(row.SM_CODE)
    setmodel_xlarge_sup(!model_xlarge_sup)

  }

  const GetSelectRowLoc = (e, row, isSelect, rowIndex) => {
    SetLocation(row.LOC_CODE)
    getLocation(row.LOC_CODE)
    setmodel_xlarge_loc(!model_xlarge_loc)

  }


  //*** End of getSelectedRow function */

  //edit button function
  const handleEdit = e => {
    setDisabledDesc(false)
    setDisabledCode(true)
    setEditEnable(false)
    setSaveEnable(true)
    SetVoucherCodeDisable(true)
    SetVoucherDateDisable(true)
    SetSupplierDisable(true)
    SetLocationDisable(true)

    SetRemarks1Enable(false)
    SetRemarks2Enable(false)
    SetAddNew(false)
    SetblDiasableGrid(false)
    setIsProcessed("")

  }

  //new button function
  const handleNew = e => {
    ClearItem()
    setAlertMsg(false)
    setSaveEnable(true)
    setEditEnable(false)
    setAlertShow(false)
  }

  //clear fields function
  const ClearItem = () => {
    let today = new Date()
    let date = today.toISOString().split("T")[0]
    SetCode("") // Set Code
    SetVoucherDate(date)
    SetSupplier("")
    setSupplierDesc("")
    SetLocation("")
    setLocationDesc("")
    SetRemarks1("")
    SetRemarks2("")
    SetdbSellingAmount("0.0")
    SetdbGrossAmount("0.0")
    SetdbDiscountPer("0.0")
    SetdbItexAmount("0.0")
    SetdbETaxAmount("0.0")
    SetdbAddAmount("0.0")
    SetdbDedAmount("0.0")
    SetdbNetAmount("0.0")
    setTotalBookQty("0.0")
    setTotalCostValue("0.0")
    setTotalSellingValue("0.0")
    SetAddNew(true)
    SetDeleteEnable(false)
    setGridRows([])
    setTax([])
    setSupplierTax([])
    setSupSearchDisable(false)
    setLocSearchDisable(false)
    SetBatchNo("")
    SetBatchNoEnable(false)
    SetblDiasableGrid(false)
    setShowTaxTable(false)
    SetVoucherCodeDisable(false)
    SetVoucherDateDisable(false)
    SetSupplierDisable(false)
    SetLocationDisable(false)
    SetRemarks1Enable(false)
    SetRemarks2Enable(false)
    setSaveEnable(true)
    setCrEnable(false)
    setVoucherProcess(0)
    setIsProcessed("")
    setEditEnable(false)
    setPrintEnable(false)
    setTimeout(() => {
      setGridRows([{
        id: 1,
        code: "",
        desc: "",
        Cost: 0.0,
        Selling: 0.0,
        StartBook: 0,
        EndBook: 0,
        NoOfBook: 0,
        CostValue: 0,
        SellingValue: 0,
        rate: 0

      }])
    }, 1)
  }


  // Set values to variables(Data Recall main method)
  const ValueSetter = async code => {

    if (code == "") return

    if (validateSpecialCharacters(code) == true) {
      SetCode("")
      return
    }
    SetLoadingAlerttitle("Loading...")
    SetLoadingAlert(true)
    let { success, data } = await getVoucherPOHeader(code, LocationCode)
    SetLoadingAlert(false)

    if (success) {
      data.map(dr => {
        setGridRows([])
        setTax([])
        let modifiedRows = []
        let modifiedRowsTax = []
        setCrEnable(true)
        setSaveEnable(false)
        SetVoucherDate(dr.dtTxnDate)
        SetSupplier(dr.strSupCode)
        getSupplier(dr.strSupCode)
        SetLocation(dr.strLocCode)
        getLocation(dr.strLocCode)
        SetRemarks1(dr.strRef1)
        SetRemarks2(dr.strRef2)
        setIsProcessed(dr.isProcessed)

        if (dr.isProcessed == 0) {
          setEditEnable(true)
        }

        SetdbSellingAmount(parseFloat(dr.dbSellingAmount).toFixed(2))
        SetdbGrossAmount(parseFloat(dr.dbGrossAmount).toFixed(2))
        SetdbDiscountPer(parseFloat(dr.dbDiscountPer).toFixed(2))
        SetdbItexAmount(parseFloat(dr.dbItexAmount).toFixed(2))
        SetdbETaxAmount(parseFloat(dr.dbETaxAmount).toFixed(2))
        SetdbAddAmount(parseFloat(dr.dbAddAmount).toFixed(2))
        SetdbDedAmount(parseFloat(dr.dbDedAmount).toFixed(2))
        SetdbNetAmount(parseFloat(dr.dbNetAmount).toFixed(2))
        setSupSearchDisable(true)
        setLocSearchDisable(true)
        setCrBy(dr.createdBy)
        //setMdBy(dr.modifiedDate)
        setCrDate(dr.createdDate)
        SetBatchNo(dr.strBatchNo)
        SetBatchNoEnable(true)
        // setMdDate(dr.modifiedBy)

        SetblDiasableGrid(true)

        SetVoucherCodeDisable(true)
        SetVoucherDateDisable(true)
        SetSupplierDisable(true)
        SetLocationDisable(true)
        SetRemarks1Enable(true)
        SetRemarks2Enable(true)
        SetAddNew(false)
        let TotNoOfBook = 0;
        let TotCostValue = 0;
        let TotSellingValue = 0;
        dr.vcpodetails.map(dr => {
          TotNoOfBook = parseFloat(TotNoOfBook) + parseFloat(dr.deT_VCBQTY);
          TotCostValue = parseFloat(TotCostValue) + parseFloat(dr.deT_CVALUE);
          TotSellingValue = parseFloat(TotSellingValue) + parseFloat(dr.deT_SVALUE);
        })
        setTotalBookQty(TotNoOfBook)
        setTotalCostValue(TotCostValue)
        setTotalSellingValue(TotSellingValue)


        dr.vcpodetails.map(dr => {
          modifiedRows.push({
            id: modifiedRows.length + 1,
            code: dr.deT_VCCAT,
            desc: dr.deT_VCCATNAME,
            Cost: dr.deT_CPRICE,
            Selling: dr.deT_SPRICE,
            StartBook: dr.deT_VCBSTART,
            rate: dr.deT_BOOKQTY,
            EndBook: dr.deT_VCBEND,
            NoOfBook: dr.deT_VCBQTY,
            CostValue: dr.deT_CVALUE,
            SellingValue: dr.deT_SVALUE,
          })
        })
        setGridRows(modifiedRows)

        dr.vcpotaxdetails.map(dr => {
          setShowTaxTable(true)
          modifiedRowsTax.push({
            id: modifiedRowsTax.length + 1,
            code: dr.tdeT_VCCAT,
            desc: dr.tdeT_VCCATDESC,
            TaxCode: dr.tdeT_TAXCODE,
            grossAmt: dr.tdeT_GROAMT,
            TaxRate: dr.tdeT_TAXRATE,
            isInclude: dr.tdeT_TAXINC,
            TaxAmount: dr.tdeT_TAXAMT,

          })
        })
        setTax(modifiedRowsTax)
        setPrintEnable(true)

      })
    } else {
      displayAlertMessage('success', 'Record Not Found !')
    }
  }



  //default sorted method
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  function getSupplier(supCode) {

    if (supCode == "" || supCode == undefined) {
      SetSupplier("")
      setSupplierDesc("")
      return
    }

    fetch(`${ApiURL}Supplier/search/${supCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          const dt = responseData.data[0]
          setSupplierDesc(dt.name)
          setSupSearchDisable(true)
          handleAddRowTax(dt.code, dt.name)
        } else {
          SetSupplier("")
          setSupplierDesc("")
          displayAlertMessage('danger', "Invalid Supplier Code")
          return
        }
      }).catch((error) => {
      })
  }

  function getLocation(locCode) {
    if (locCode == "" || locCode == undefined) {
      SetLocation("")
      setLocationDesc("")
      return
    }
    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };
    fetch(`${ApiURL}Locations/SearchCode/${locCode}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        const dt = result.data[0];
        if (result.success == true) {
          setLocationDesc(dt.name)
          setLocSearchDisable(true)
        }
        else {
          SetLocation("")
          setLocationDesc("")
          displayAlertMessage('danger', "Invalid Location Code")
          return
        }
      })
      .catch(error => console.log('error', error));
  }




  const PermissionGrant = operation => {
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode,
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(permissiondata),
    })
      .then(Response => {
        if (Response.status == "200") {
          Response.json().then(responseData => {
            let Access = responseData.data.strMenuAccessRight
            let Create = responseData.data.strMenuCreateRight
            let Delete = responseData.data.strMenuDeleteRight
            let Modify = responseData.data.strMenuModifyRight
            let Print = responseData.data.strMenuPrintRight
            let Process = responseData.data.strMenuProcessRight
            debugger
            if (operation == "Save") {
              if (Create == true && addNew == true) {

                handlesave(1)

              } else if (Modify == true && addNew == false) {

                handlesave(1)

              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")
                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")
                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {

              } else {
                displayAlertMessage('danger', "This user don't have permission to cancel document !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          })
        } else if (Response.status == "400") {
          displayAlertMessage('danger', "Oops something went wrong !")
          clearPermissionInputs()

        } else if (Response.status == "403") {
          displayAlertMessage('danger', "You have not Permission to make changes !")
          clearPermissionInputs()

        } else if (Response.status == "404") {
          setAlertColor("danger")
          setAlertMsg("Incorrect Login Details !")
          setAlertShow(true)
          setTimeout(() => {
            setAlertShow(false)
          }, time)
          displayAlertMessage('danger', "Password or User Name is Invalid !")
          return
        } else {
          ClearItem()
        }
      })
      .catch(error => {
        console.log(error.message)
      })
  }


  async function handlePrint(option) {
    var option = option
    const authToken = localStorage.getItem("authToken")

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")


    const ReportURL = window.Links.ReportURL
    await fetch(`${ReportURL}api/VoucherPO/report/${LogUserType}/${strVoucherCode}/${strLocation}/${option == "PDF" ? 1 : 0}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (option == "PDF") {
            {
              const msg = responseData.msg
              window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
            }
          }
          if (option == "XCEL") {
            {
              const msg = responseData.msg
              window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
            }
          }

        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
        SetLoadingAlert(false)
      })
  }

  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setAlertShow(true)

    setTimeout(() => {
      setAlertShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }

  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
    console.log(response)
  }


  const validateSpecialCharacters = (str) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharRegex.test(str);
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumb
            title={parentName}
            breadcrumbItem={menuName}
          ></Breadcrumb>
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {

                // setAlertDescription("Do you wish to process this document ?")
                // setAlertConfirmOption(5)
                // setsweetAlertShow(true)

                setVoucherProcess(1)
                if (strVoucherCode == "" && menuCreate == true && permissionReasonShow == false) {
                  handlesave(1)
                } else if (strVoucherCode == "" && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (strVoucherCode != "" && menuModify == true && permissionReasonShow == false) {
                  handlesave(1)
                } else if (strVoucherCode != "" && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionName("")
                  setPermissionNameDisable(false)
                  setPermissionAlertShow(true)
                }
              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                window.location.href = "/"
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 5) {
                setVoucherProcess(1)
                if (strVoucherCode == "" && menuCreate == true && permissionReasonShow == false) {
                  handlesave(1)
                } else if (strVoucherCode == "" && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (strVoucherCode != "" && menuModify == true && permissionReasonShow == false) {
                  handlesave(1)
                } else if (strVoucherCode != "" && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionName("")
                  setPermissionNameDisable(false)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 6) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)
                } else {
                  setPermissionName("")
                  setPermissionNameDisable(false)
                  setPermissionAlertShow(true)
                }
              }
            }}
            onCancel={() => {
              setsweetAlertShow(false)
              clearPermissionInputs()
              if (AlertConfirmOption == 5) {
                setVoucherProcess(0)
                if (strVoucherCode == "" && menuCreate == true && permissionReasonShow == false) {
                  handlesave(0)
                } else if (strVoucherCode == "" && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (strVoucherCode != "" && menuModify == true && permissionReasonShow == false) {
                  handlesave(0)
                } else if (strVoucherCode != "" && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionName("")
                  setPermissionNameDisable(false)
                  setPermissionAlertShow(true)
                }
              }
            }}
            SupplierOpen={SupplierOpen}
            SetSupplieropen={() => {
              SetSupplieropen(!SupplierOpen)
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            show={permissionGrantedAlertShow}
            AlertColor={permissionGrantedAlertColor}
            AlertMsg={permissionGrantedAlertMsg}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", false)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, true, "any", false)
              setPermissionPassword(val2)
            }}
            AlReason={strReason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              //ws.close()
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                PermissionGrant("Save")
              } else if (AlertConfirmOption == 5) {
                PermissionGrant("Save")
              } else if (AlertConfirmOption == 7) {
                PermissionGrant("Delete")
              } else if (AlertConfirmOption == 6) {
                PermissionGrant("Print")
                // setprintoptionShow(true)
              }
            }}
            onCancel={() => {
              //ws.close()
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}
            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={editEnable}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={printEnable}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to print ?");
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={false}
                    deleteClick={() => {
                      alert("Delete")
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  {isProcessed == "1" || isProcessed == "0" ? (
                    <Alert
                      color={"dark"}
                      role="alert"
                    >
                      {isProcessed == 1 ? "Processed Document!" : "Unprocessed Document!"}
                    </Alert>
                  ) : null}
                  <Row>
                    <VoucherPurchaseOrderContent
                      Gen_DataSearch={async () => {
                        tog_xlarge()
                      }}
                      DataTables={DataTables}
                      Hed_CodeSearchOpen={modal_xlarge}
                      Hed_CodeSearchTrigger={tog_xlarge}
                      AlertColor={AlertColor}
                      AlertMsg={AlertMsg}
                      show={AlertShow}
                      Gen_Code={strVoucherCode}
                      Gen_Code_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          13,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetCode(valCode)
                      }}
                      Gen_Code_onBlur={e => {
                        ValueSetter(e.target.value)
                      }}
                      Gen_Code_Enabled={blVoucherCodeEnable}
                      Gen_Supplier={strSupplier}

                      Gen_Supplier_Enabled={blSupplierEnable}
                      Gen_Location={strLocation}

                      Gen_Location_Enabled={blLocationEnable}
                      Gen_TxnDate={strVoucherDate}
                      Gen_TxnDate_OnChange={e => {
                        SetVoucherDate(e.target.value)
                      }}
                      Gen_TxnDate_Enabled={blVoucherDateEnable}
                      Gen_Remark1={strRemarks1}
                      Gen_Remark1_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRemarks1(valCode)
                      }}
                      Gen_Remark1_Enabled={blRemarks1Enable}
                      Gen_Remark2={strRemarks2}
                      Gen_Remark2_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRemarks2(valCode)
                      }}
                      Gen_Remark2_Enabled={blRemarks2Enable}
                      SearchDataTables={DataTables}
                      SearchDefaultSorted={defaultSorted}
                      SearchModelOpen={modal_xlarge}
                      SearchModelTrigger={tog_xlarge}
                      SearchGetSelectRow={GetSelectRow}
                      menuName={menuName}
                      menuCode={menuCode}
                      LocationCode={LocationCode}
                      supplierDesc={supplierDesc}
                      locationDesc={locationDesc}
                      supplierOnblur={e => {
                        getSupplier(e.target.value)
                      }}
                      locationOnblur={e => {
                        getLocation(e.target.value)
                      }}
                      tox_xlarge_loc={tox_xlarge_loc}
                      tox_xlarge_sup={tox_xlarge_sup}
                      model_xlarge_loc={model_xlarge_loc}
                      model_xlarge_sup={model_xlarge_sup}
                      Gen_Location_OnChange={e => {
                        let val1 = Text(
                          e.target,
                          5,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetLocation(val1)
                      }}
                      Gen_Supplier_OnChange={e => {

                        let val1 = Text(
                          e.target,
                          10,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetSupplier(val1)
                      }}
                      GetSelectRowSup={GetSelectRowSup}
                      GetSelectRowLoc={GetSelectRowLoc}
                      supSearchDisable={supSearchDisable}
                      locSearchDisable={locSearchDisable}
                      Gen_BatchNo={strBatchNo}
                      Gen_BatchNo_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          15,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetBatchNo(valCode)
                      }}
                      Gen_BatchNo_Enabled={blBatchNoEnable}
                    />
                  </Row>
                  <Row>
                    <VoucherPurchaseOrderDetails
                      DataRow={GridRows}
                      RemoveRow={handleRemoveRow}
                      BookChange={BookChange}
                      AddRow={handleAddRowNested}
                      Disabled={disabled}
                      GrossAmount={dbGrossAmount}
                      SellingAmount={dbSellingAmount}
                      DiscountPer={dbDiscountPer}
                      DiscountPer_OnChange={e => {
                        let valDiscountPer = Numeric(e.target, 8, 2, false)
                        if (valDiscountPer == "") {
                          SetdbDiscountPer(parseFloat(0).toFixed(2))
                        } else {
                          SetdbDiscountPer(valDiscountPer)
                        }
                      }}
                      DiscountPer_OnBlur={e => {
                        let valDiscountPer = DecimalValidation(e.target.value)
                        if (valDiscountPer <= 100) {
                          // let NetAmount = (parseFloat(dbGrossAmount) + parseFloat(dbAddAmount) + parseFloat(dbETaxAmount)) - ((parseFloat(dbGrossAmount) * parseFloat(e.target.value)) / 100 + parseFloat(dbDedAmount))
                          //SetdbNetAmount(parseFloat(NetAmount, 10).toFixed(2))
                          SetdbDiscountPer(valDiscountPer)
                        } else {
                          SetdbDiscountPer(0.0)
                        }
                        BookChange()
                      }
                      }
                      ITaxAmount={dbItexAmount}
                      texAmount_OnChange={e => {
                        SetdbItexAmount(dbItexAmount)
                      }}
                      ETaxAmount={dbETaxAmount}
                      ETaxAmount_OnChange={e => {
                        SetdbETaxAmount(dbETaxAmount)
                      }}
                      AddAmount={dbAddAmount}
                      AddAmount_OnChange={e => {
                        let valAddAmount = DecimalValidation(e.target.value)
                        SetdbAddAmount(valAddAmount)
                        if (valAddAmount == "") {
                          SetdbAddAmount(0.0)
                        } else {
                          SetdbAddAmount(e.target.value)
                        }
                      }}
                      AddAmount_OnBlur={e => {
                        let valAddAmount = DecimalValidation(e.target.value, 0, true, 2)
                        SetdbAddAmount(valAddAmount)
                        // if (valAddAmount == "") {
                        //   SetdbAddAmount(0.0)
                        // } else {
                        //   //let NetAmount = (parseFloat(dbGrossAmount) + parseFloat(e.target.value) + parseFloat(dbETaxAmount)) - ((parseFloat(dbGrossAmount) * parseFloat(dbDiscountPer)) / 100 + parseFloat(dbDedAmount))
                        //   //SetdbNetAmount(parseFloat(NetAmount, 10).toFixed(2))
                        //   SetdbAddAmount(parseFloat(e.target.value, 10).toFixed(2))
                        // }
                        BookChange()
                      }}
                      DedAmount={dbDedAmount}
                      DedAmount_OnChange={e => {
                        let valDedAmount = Numeric(e.target, 8, 2, false)
                        if (valDedAmount == "") {
                          SetdbDedAmount(0.0)
                        } else {
                          SetdbDedAmount(e.target.value)
                        }
                      }}
                      DedAmount_OnBlur={e => {
                        let valDedAmount = DecimalValidation(e.target.value, 0, true, 2)
                        SetdbDedAmount(valDedAmount)
                        // if (valDedAmount == "") {
                        //   SetdbDedAmount(0.0)
                        // } else {
                        //   //let NetAmount = (parseFloat(dbGrossAmount) + parseFloat(dbAddAmount) + parseFloat(dbETaxAmount)) - ((parseFloat(dbGrossAmount) * parseFloat(dbDiscountPer)) / 100 + parseFloat(e.target.value))
                        //   //SetdbNetAmount(parseFloat(NetAmount, 10).toFixed(2))
                        //   SetdbDedAmount(parseFloat(e.target.value, 10).toFixed(2))
                        // }
                        BookChange()
                      }}
                      NetAmount={dbNetAmount}
                      TotalBookQty={TotalBookQty}
                      TotalCostValue={TotalCostValue}
                      TotalSellingValue={TotalSellingValue}
                      rowsTax={rowsTax}
                      SupplierCode={strSupplier}
                      ShowTaxTable={ShowTaxTable}
                      blDiasableGrid={blDiasableGrid}
                      menuCode={menuCode}
                      setGridRows={setGridRows}
                      SupplierTax={SupplierTax}
                      setSupplierTax={setSupplierTax}
                      setTax={setTax}

                    />
                  </Row>

                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default VoucherPurchaseOrder
